// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1r-7";
export var adjustableWidthBorderHeld = "_1r-8";
export var arrow = "_1r-3";
export var arrowButton = "_1r-4";
export var headerCell = "_1r-0";
export var help = "_1r-2";
export var icon = "_1r-1";
export var iconWrapper = "_1r-6";
export var noBorder = "_1r-b";
export var nonAdjustableWidthBorder = "_1r-9";
export var nonAdjustableWidthBorderHeld = "_1r-a";
export var textButton = "_1r-5";